export default __webpack_public_path__ + "static/Ambit-Black-df99ddd8cd3224aa6a0395bb2a967f65.woff";